<script>
import CertificatesItem from "@/components/certificates/CertificatesItem.vue";

export default {
  name: "CertificatesList",

  components: { CertificatesItem },

  props: {
    certificates: {
      type: Array,
      default: () => [],
    },

    selectedStatus: {
      type: String,
      required: true,
    },
  },
};
</script>

<template>
  <div class="certificates-list">
    <template v-if="certificates.length">
      <CertificatesItem
        v-for="certificate in certificates"
        :key="certificate.id"
        :certificate="certificate"
      />
    </template>

    <template v-else-if="certificates.length === 0 && selectedStatus === 'all'">
      <p class="certificates-view__info">
        У вас не куплен еще ни один сертификат
      </p>
    </template>

    <template v-else-if="certificates.length === 0 && selectedStatus === 'new'">
      <p class="certificates-view__info">
        У вас пока нет активных сертификатов
      </p>
    </template>

    <template
      v-else-if="certificates.length === 0 && selectedStatus === 'activated'"
    >
      <p class="certificates-view__info">
        У вас пока нет использованных сертификатов
      </p>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.certificates-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>
